import React, { ReactElement, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { getQueryString } from 'mockStores/lib/utils';
import CopyField from './CopyField';

const useStyles = createUseStyles({
  bottom: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
});

function copy(text) {
  try {
    const input = document.createElement('textarea');
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand('copy');
    input.remove();
    return true;
  } catch (e) {
    return false;
  }
}

function MockVcc(): ReactElement {
  const defaultCopiedState = {
    cardNumber: false,
    cvv: false,
    expirationDateString: false,
  };
  const [copied, setCopied] = useState(defaultCopiedState);

  const card = {
    cardNumber: getQueryString('cardNumber', '1234123412341234'),
    cvv: getQueryString('cvv', '123'),
    expirationDateString: getQueryString('expirationDateString', '01/23'),
  };

  const { cardNumber, cvv, expirationDateString } = card;

  const classes = useStyles();
  const handleCopyToClipboard = (text, type) => () => {
    copy(text);

    setCopied({
      ...defaultCopiedState,
      [type]: true,
    });
  };

  return (
    <div className={ classes.bottom }>
      { cardNumber && (
      <CopyField
        id="cardNumber"
        title="VCC number"
        value={ cardNumber }
        isCopied={ copied.cardNumber }
        handleCopyToClipboard={ handleCopyToClipboard }
      />
      ) }
      { cvv && (
      <CopyField
        id="cvv"
        title="CVV"
        value={ cvv }
        isCopied={ copied.cvv }
        handleCopyToClipboard={ handleCopyToClipboard }
      />
      ) }
      { expirationDateString && (
      <CopyField
        id="expirationDateString"
        title="Expiration Date"
        value={ expirationDateString }
        isCopied={ copied.expirationDateString }
        handleCopyToClipboard={ handleCopyToClipboard }
      />
      ) }
    </div>
  );
}

export default MockVcc;
